<template>
  <TemplateOnboarding @save="save">
    Content
  </TemplateOnboarding>
</template>

<script>
import TemplateOnboarding from "@/components/template/onboarding/index.vue";

export default {
  name: "TemplateOnboardingPage",
  components: {
    TemplateOnboarding,
  },
  data() {
    return {
      steps: [
        { name: 'Dashboard', route: '/dashboard', timestamp: new Date() },
        {
          name: 'Bank Information',
          complete: false,
          route: '/template/onboarding',
          timestamp: new Date()
        },
        {
          name: 'Micro-Deposits',
          complete: false,
          route: '/pattern/progress-bar',
          timestamp: new Date()
        },
        {
          name: 'Verify Account',
          complete: false,
          route: '/template/onboarding',
          timestamp: new Date()
        }
      ]
    }
  },
  methods: {
    save() {
      this.$router.push('/pattern/progress-bar')
    }
  }
};
</script>

<style scoped lang="scss">
</style>
